import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';

import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';
import LearningAdminModuleForm from '../containers/LearningAdminModuleFormContainer';
import {
  MixpanelTracker,
  mixpanelEventsEnum,
} from '../../../../../lib/Mixpanel';

const LearningAdminModuleAddScreen = ({
  history,
  location,
  role,
  ...props
}) => {
  const scrollToTop = () => {
    Logger.log('debug', `LearningAdminModuleAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  const trackerActions = (eventMixpanel, params = {}) => {
    if (role !== 1) {
      MixpanelTracker.mixpanelTrack(eventMixpanel, {
        partnershipName: props.partnershipName ?? 'No partnership',
        partnershipId: props.partnershipId ?? 'No partnership',
        ...params,
      });
    }
  };

  useEffect(() => {
    scrollToTop();
    trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.LEARNINGS_ADMIN_ADD_SCREEN_MODULE
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Translation>
      {(t) => (
        <div>
          <DocumentHead title={t('learnings_route_add')} />
          <LearningAdminModuleForm
            history={history}
            location={location}
            trackerActions={trackerActions}
          />
        </div>
      )}
    </Translation>
  );
};

export default LearningAdminModuleAddScreen;

Logger.log('silly', `LearningAdminModuleAddScreen loaded.`);
